import React, { useEffect, useState } from 'react';
import 'react-phone-number-input/style.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, Form, Col } from "react-bootstrap";
import CpfCnpj from "@react-br-forms/cpf-cnpj-mask";
//imports core
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import useAuth from "hooks/useAuth"
import PhoneInput from 'react-phone-number-input'
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import api from "assets/services/api";
import TimeInput from 'services/TimeInput';
//imports material
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import Checkbox from '@material-ui/core/Checkbox';
import AddAlert from "@material-ui/icons/AddAlert";

const styles = {
    btnFindClient: {
        backgroundColor: "#4169e1",
        marginTop: "25%",
        '&:hover': {
            backgroundColor: '#303f9f',
        },
    },
    sizeAddContact: {
        color: "#4169e1",
        overflow: "visible"
    },
    buttonIcon: {
        fontSize: "50px",
        padding: "0"
    },

};

const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);

function ModalAddSell(props) {
    const classStyles = useStyles();
    const classStyles2 = useStyles2();
    const { storageId } = useAuth();
    const typeContacts = ["COMPRAS", "FINANCEIRO", "RESPONSAVEL"];

    const [br, setBR] = useState(false);
    const [cnpj, setCnpj] = useState();
    const [mask, setMask] = useState("");
    const [obs, setObs] = useState("");
    const [social_reason, setSocial_reason] = useState("");
    const [fantasy_name, setFantasy_name] = useState("");
    const [contacts, setContacts] = useState([{ name: '', number: '', email: '', type: '' }])
    const [address_delivery, setAddress_delivery] = useState("");
    const [reference_comercial, setReference_comercial] = useState("");
    const [hour_delivery, setHour_delivery] = useState(['00:00', '23:59']);
    const [address, setAddress] = useState("");
    const [id_enterprise, setId_enterprise] = useState("");
    const [enterprises, setEnterprises] = useState([]);
    const [buttonClient, setButtonClient] = useState(true)
    const [controlSnack, setControlSnack] = useState(false);
    const [sellsmans, setSellsmans] = useState([]);
    const [sellsmanId, setSellsmanId] = useState();
    const [state_reg, setState_reg] = useState();
    const [latitude, setLatitude] = useState();
    const [longitude, setLongitude] = useState();
    const [number, setNumber] = useState();
    const [complement, setComplement] = useState();
    const [uf, setUf] = useState();
    const [cep, setCep] = useState();
    const [city, setCity] = useState();
    const [neighborhood, setNeighborhood] = useState();
    const [email, setEmail] = useState();
    const [preference, setPreference] = useState(props.props.preference);
    const [preferences, setPreferences] = useState([]);
    const [carrier, setCarrier] = useState(false);
    useEffect(() => {
        loadSellsman();
        loadPayments();
        loadEnterprises();
    }, []);

    useEffect(() => {
        if (controlSnack) showNotification("br")
    }, [controlSnack]);

    useEffect(() => {
        if (contacts.length == 3) setButtonClient(false)
    }, [contacts]);
    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };
    const loadPayments = async () => {
        const responsePayment = await api.get('/payment')
        setPreferences(responsePayment.data);
    };
    async function handleAddClient(e) {
        e.preventDefault();
        const response = await api.post('/client', {
            cnpj: cnpj,
            social_reason: social_reason,
            fantasy_name: fantasy_name,
            id_admin: storageId,
            address_delivery: address_delivery,
            hour_delivery: `${hour_delivery[0]}-${hour_delivery[1]}`,
            reference_comercial: reference_comercial,
            observation: obs,
            contacts: contacts,
            preference: preference,
            id_sellsman: sellsmanId,
            cep: cep,
            stateReg: state_reg,
            neighborhood: neighborhood,
            city: city,
            address: address,
            email: email,
            complement: complement,
            latitude: latitude,
            longitude: longitude,
            number: number,
            uf: uf,
            carrier,
            id_enterprise
        });
        if (response.status === 210) {
            return alert(response.data.message);
        };
        props.getAllClients();
        props.onHide();
        setObs("")
        setCnpj("")
        setSocial_reason("")
        setFantasy_name("")
        setAddress("")
    };
    async function findClient(cnpj) {
        const response = await api.post('client/find', {
            cnpj: cnpj,
            id_admin: storageId
        });
        if (response.status === 210) {
            return alert(response.data.message);
        };
        setState_reg(response.data[0].state_reg)
        setSocial_reason(response.data[0].social_reason)
        setFantasy_name(response.data[0].fantasy_name)
        setAddress(response.data[0].address)
        setUf(response.data[0].uf)
        setCity(response.data[0].city)
        setNeighborhood(response.data[0].neighborhood)
        setCep(response.data[0].cep)
        setEmail(response.data[0].email)
        setComplement(response.data[0].complement)
        setLatitude(response.data[0].latitude)
        setLongitude(response.data[0].longitude)
        setNumber(response.data[0].number)
    };
    async function loadSellsman() {
        const response = await api.get('sellsman/admin/type/all/' + storageId)
        setSellsmans(response.data);
        if (response.data.length > 0) {
            setSellsmanId(response.data[0].id)
        };
    };
    async function loadEnterprises() {
        const response = await api.get(`/enterprise/${storageId}`);
        console.log(response.data)
        setEnterprises(response.data.enterprises);
        if (response.data.enterprises.length > 0) {
            setId_enterprise(response.data.enterprises[0].id)
        };
    };
    async function addContacts() {
        setContacts([...contacts, { name: '', number: '', email: '', type: '' }]);
    };
    async function actualizeContacts(index, input, value) {
        const newContacts = [...contacts];
        newContacts[index][input] = value;
        setContacts(newContacts);
    };
    async function addHours(e, type) {
        // e.preventDefault();
        console.log([e.target.value, hour_delivery[1]])
        if (type === 'start') {
            setHour_delivery([e.target.value, hour_delivery[1]]);
        } else if (type === 'end') {
            setHour_delivery([hour_delivery[0], e.target.value]);
        };
    };
    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Adicionar cliente
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleAddClient}>
                <Modal.Body>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridName">
                            <Form.Label>CNPJ/CPF</Form.Label>
                            <CpfCnpj
                                value={cnpj}
                                className="form-control"
                                placeholder="Digite um CPF ou CNPJ"
                                type="tel"
                                onChange={(event, type) => {
                                    setCnpj(event.target.value);
                                    setMask(type === "CPF");
                                }}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Button as={Col} className={classStyles.btnFindClient} onClick={() => findClient(cnpj)} >
                                Buscar
                            </Button>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridName">
                            <Form.Label>RAZÃO SOCIAL</Form.Label>
                            <Form.Control
                                value={social_reason}
                                className="form-control"
                                placeholder="Razão social"
                                type="text"
                                onChange={(event) => {
                                    setSocial_reason(event.target.value)
                                }}
                            />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridName">
                            <Form.Label>NOME FANTASIA</Form.Label>
                            <Form.Control
                                value={fantasy_name}
                                className="form-control"
                                placeholder="Nome fantasia"
                                type="text"
                                onChange={(event) => {
                                    setFantasy_name(event.target.value)
                                }}
                            />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} xs={4} controlId="formGridName">
                            <Form.Label>ENDEREÇO</Form.Label>
                            <Form.Control
                                value={address}
                                className="form-control"
                                placeholder="Endereço"
                                type="text"
                                onChange={(event) => {
                                    setAddress(event.target.value)
                                }}
                            />
                        </Form.Group>
                        <Form.Group as={Col} xs={4} controlId="formGridName">
                            <Form.Label>COMPLEMENTO</Form.Label>
                            <Form.Control
                                value={complement}
                                className="form-control"
                                placeholder="Complemento"
                                type="text"
                                onChange={(event) => {
                                    setComplement(event.target.value)
                                }}
                            />
                        </Form.Group>
                        <Form.Group as={Col} xs={1} controlId="formGridName">
                            <Form.Label>NUMERO</Form.Label>
                            <Form.Control
                                value={number}
                                className="form-control"
                                placeholder="Numero"
                                type="text"
                                onChange={(event) => {
                                    setNumber(event.target.value)
                                }}
                            />
                        </Form.Group>
                        <Form.Group as={Col} xs={3} controlId="formGridName">
                            <Form.Label>BAIRRO</Form.Label>
                            <Form.Control
                                value={neighborhood}
                                className="form-control"
                                placeholder="Bairro"
                                type="text"
                                onChange={(event) => {
                                    setNeighborhood(event.target.value)
                                }}
                            />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} xs={4} controlId="formGridName">
                            <Form.Label>CIDADE</Form.Label>
                            <Form.Control
                                value={city}
                                className="form-control"
                                placeholder="Cidade"
                                type="text"
                                onChange={(event) => {
                                    setCity(event.target.value)
                                }}
                            />
                        </Form.Group>
                        <Form.Group as={Col} xs={1} controlId="formGridName">
                            <Form.Label>ESTADO</Form.Label>
                            <Form.Control
                                value={uf}
                                className="form-control"
                                placeholder="UF"
                                type="text"
                                onChange={(event) => {
                                    setUf(event.target.value)
                                }}
                            />
                        </Form.Group>
                        <Form.Group as={Col} xs={2} controlId="formGridName">
                            <Form.Label>CEP</Form.Label>
                            <Form.Control
                                value={cep}
                                className="form-control"
                                placeholder="CEP"
                                type="text"
                                onChange={(event) => {
                                    setCep(event.target.value)
                                }}
                            />
                        </Form.Group>
                        <Form.Group as={Col} xs={5} controlId="formGridName">
                            <Form.Label>EMAIL PARA NF</Form.Label>
                            <Form.Control
                                value={email}
                                className="form-control"
                                placeholder="Email nota fiscal"
                                type="text"
                                onChange={(event) => {
                                    setEmail(event.target.value)
                                }}
                            />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridName">
                            <Form.Label>CONTATOS</Form.Label>
                        </Form.Group>
                    </Form.Row>

                    <Form.Group as={Col} controlId="formGridName">
                        {contacts.map((contact, index) => (
                            <div key={index}>
                                <Form.Row>
                                    <Form.Group as={Col} controlId={`name-${index}`}>
                                        <Form.Control
                                            value={contact.name}
                                            className="form-control"
                                            placeholder="Nome compras"
                                            type="text"
                                            required
                                            onChange={(event) => {
                                                actualizeContacts(index, 'name', event.target.value)
                                            }}
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} controlId={`number-${index}`}>
                                        <PhoneInput
                                            defaultCountry="BR"
                                            className="form-control"
                                            placeholder="Contato compras"
                                            value={contact.number}
                                            required
                                            onChange={(phoneNumber) => {
                                                actualizeContacts(index, 'number', phoneNumber)
                                            }}
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} controlId={`email-${index}`}>
                                        <Form.Control
                                            value={contact.email}
                                            className="form-control"
                                            placeholder="email compras"
                                            type="text"
                                            onChange={(event) => {
                                                actualizeContacts(index, 'email', event.target.value)
                                            }}
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="{`type-${index}`}">
                                        <Form.Control onChange={(event) => {
                                            actualizeContacts(index, 'type', event.target.value)
                                        }} value={contact.type} as="select" defaultValue="Choose...">
                                            {typeContacts.map(typeContact => (
                                                <option key={String(typeContact)} value={typeContact}>{typeContact}</option>
                                            ))}
                                        </Form.Control>
                                    </Form.Group>
                                </Form.Row>
                            </div>
                        ))}
                        <Form.Group as={Col} controlId="formGridName" className="d-flex justify-content-center">
                            {buttonClient ?
                                <Tooltip
                                    id="tooltip-top"
                                    title="Adicionar contato"
                                    placement="right"
                                    classes={{ tooltip: classStyles2.tooltip }}
                                >
                                    <IconButton
                                        aria-label="Edit"
                                        className={classStyles.buttonIcon}
                                        onClick={() => addContacts()}

                                    >
                                        <AddCircleOutlineIcon
                                            sx={{ fontSize: 40 }}
                                            className={
                                                classStyles.sizeAddContact + " " + classStyles.addContacts
                                            }
                                        />
                                    </IconButton>
                                </Tooltip>
                                : <></>}
                        </Form.Group>
                    </Form.Group>

                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridName">
                            <Form.Label>ENDEREÇO ENTREGA</Form.Label>
                            <Form.Control
                                value={address_delivery}
                                className="form-control"
                                placeholder="Endereço entrega"
                                type="text"
                                onChange={(event) => {
                                    setAddress_delivery(event.target.value)
                                }}
                                required={storageId === 3 ? true : false} // Only required for admin
                            />
                        </Form.Group>
                        <Form.Group as={Col} controlId="{`type-${index}`}">
                            <Form.Label>DEPOSITO</Form.Label>
                            <Form.Control onChange={event => setId_enterprise(event.target.value)} value={preference} as="select" defaultValue="Choose...">
                                {enterprises.map(enterprise => (
                                    <option key={String(enterprise.id)} value={enterprise.id}>{enterprise.name}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group as={Col} xs={2} controlId="formGridSellsman" >
                            <Form.Label>TRANPORTADORA</Form.Label>
                            <div>
                                <Checkbox checked={carrier} onChange={(e) => setCarrier(e.target.checked)} inputProps={{ 'aria-label': 'primary checkbox' }} />
                            </div>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row >
                        <Form.Group as={Col} controlId="formGridSellsman" >
                            <Form.Label>Vendedores</Form.Label>
                            <Form.Control onChange={event => setSellsmanId(event.target.value)} value={sellsmanId} as="select" defaultValue="Choose...">
                                {sellsmans.map(sellsman => (
                                    <option key={String(sellsman.id)} value={sellsman.id}>{sellsman.name + " " + sellsman.lastname}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridName" >
                            <Form.Label>HORARIO DE ENTREGA</Form.Label>
                            <Form.Row>
                                <Form.Group xs={12} sm={12} md={5} controlId="formGridName" >
                                    <TimeInput
                                        name="appointment-time"
                                        value={hour_delivery[0]}
                                        onChange={(e) => {
                                            addHours(e, 'start')
                                        }}
                                        placeholder="Digite o horário"
                                    />
                                </Form.Group>
                                <Form.Group xs={12} sm={12} md={2} controlId="formGridName" >
                                    <Form.Label style={{ padding: '1em 3em 3em 3em', fontWeight: 'bold', color: 'black' }}>às</Form.Label>
                                </Form.Group>
                                <Form.Group xs={12} sm={12} md={5} controlId="formGridName" >
                                    <TimeInput
                                        name="appointment-time"
                                        value={hour_delivery[1]}
                                        onChange={(e) => {
                                            addHours(e, 'end')
                                        }}
                                        placeholder="Digite o horário"
                                    />
                                </Form.Group>
                            </Form.Row>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridName">
                            <Form.Label>REFERENCIA COMERCIAL</Form.Label>
                            <Form.Control
                                value={reference_comercial}
                                className="form-control"
                                placeholder="Referencia comercial"
                                type="text"
                                onChange={(event) => {
                                    setReference_comercial(event.target.value)
                                }}
                            />
                        </Form.Group>
                        <Form.Group as={Col} controlId="{`type-${index}`}">
                            <Form.Label>FORMA PAGAMENTO</Form.Label>
                            <Form.Control onChange={event => setPreference(event.target.value)} value={preference} as="select" defaultValue="Choose...">
                                {preferences.map(preference => (
                                    <option key={String(preference.id)} value={preference.description}>{preference.description}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridName">
                            <Form.Label>OBSERVAÇÃO</Form.Label>
                            <Form.Control
                                value={obs}
                                className="form-control"
                                placeholder="Observação"
                                type="text"
                                onChange={(event) => {
                                    setObs(event.target.value)
                                }}
                            />
                        </Form.Group>
                    </Form.Row>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button type="submit" color="success">
                            Adicionar
                        </Button>
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message="Cliente adicionado com sucesso"
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                </Modal.Footer>
            </Form>
        </Modal >
    );
}

export default ModalAddSell;